<template>
<div>
  <h5><i aria-hidden="true" data-icon="}"></i>Timeline</h5>
  <ul>
    <li v-for="job in jobs" class="clearfix top" :id="job.id" :key="job.id">
      <!--list-->
      <div class="dot"><b></b></div>

      <div class="con">
        <h3>{{job.company}}</h3>
        <p>{{job.title}}</p>
        <p class="desc">{{job.start}} - {{job.end}}</p>
      </div>
    </li>
  </ul>
</div>
</template>

<<script>
export default {
  name: 'timeline',
  props: {
    jobs: Array
  }
}
</script>

<<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Timeline.vue